/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from 'react';
import styled from './index.module.scss';
import Terms from './Terms';
import Banner from './Banner';
import BestSellers from './BestSellers';
import Accessories from './Accessories';
import MyBonus from './MyBonus';
import CountDownTip from './CountDownTip';
import { useContainer } from './StoreProvider';
import { getTotalPrice, getRewards } from './utils';
import { ProductModule } from '@/components/MembersDay/type';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { EcoProvider } from 'lowcode/utils/context/ecocredits';
import Product from 'lowcode/pages/product';
import MemberGloData from 'lowcode/utils/MemberGloData';
import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import * as LowcompMember from 'lowcomp/plugins/member/indexS';
import * as LowcompIndex from 'lowcomp/plugins/index-series/indexS';

const allTemp = {
    ...LowcompIndex,
    ...LowcompMember,
};

function MembersStoreCompoment({ id, data }: any) {
    const { locale } = getLocal();
    const [isShowBottomTip, setIsShowBottom] = useState(false);
    const [timeStamp, setTimeStamp] = useState(0);
    const { t } = useLang('membersstore');
    const { t: ecocredits } = useLang('ecocredits');
    const { onChange, priceInfo, isLogin } = useContainer();

    // 是否配置了
    const isConf = data?.theTemp && data?.theTemp.length > 0;

    useEffect(() => {
        if (isLogin) {
            getTotalPrice(
                locale,
                (data) => {
                    onChange?.('priceInfo', data);
                },
                t,
            );
            getRewards(
                locale,
                (data) => {
                    onChange?.('couponList', data);
                },
                ecocredits,
            );
        }
    }, [isLogin]);

    useEffect(() => {
        if (priceInfo) {
            const { receiveStatus, useStatus, endTime } = priceInfo;

            if (isLogin && receiveStatus === 2 && useStatus === 'UNUSED') {
                setTimeStamp(Number(endTime));
                setIsShowBottom(true);
            }
        }
    }, [priceInfo, isLogin]);

    return (
        <>
            <div className={`${styled.MembersCompoment}`}>
                <Banner isLogin={isLogin} />
                {isLogin && <MyBonus />}
                {isConf ? (
                    <MemberTimeProvider>
                        <MemberGloData isOpenA={true} />
                        <EcoProvider>
                            <Product id={id} data={data} allTemp={allTemp} />
                        </EcoProvider>
                    </MemberTimeProvider>
                ) : (
                    <>
                        <div className="members-store-over"></div>
                        <BestSellers module={ProductModule.BEST_SELLERS} title={t('bestseller.title')} subtitle={t('bestseller.subtitle')} />
                        <div className="members-store-over"></div>
                        <Accessories module={ProductModule.ACCESSORIES} title={t('accessories.title')} subtitle={t('accessories.subtitle')} />
                        <div className="members-store-over"></div>
                        <Terms />
                        {isShowBottomTip && (
                            <>
                                <div className="members-store-over"></div>
                                <CountDownTip timeStamp={timeStamp} closeTip={setIsShowBottom} />
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    );
}

export default MembersStoreCompoment;
